/**
 * Chart Metadata Component
 * Displays period, cache status, and response time below charts
 */

import React from 'react';

interface ChartMetadataProps {
  periodStart?: string;
  periodEnd?: string;
  cacheStatus?: 'HIT' | 'MISS' | string;
  responseTimeMs?: number;
  className?: string;
}

export const ChartMetadata: React.FC<ChartMetadataProps> = ({
  periodStart,
  periodEnd,
  cacheStatus,
  responseTimeMs,
  className = ''
}) => {
  if (!periodStart && !cacheStatus && !responseTimeMs) {
    return null;
  }

  return (
    <div className={`text-xs text-gray-500 dark:text-gray-400 pt-3 border-t border-gray-200 dark:border-gray-700 ${className}`}>
      {/* Desktop: side-by-side layout | Mobile: stacked for readability */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1 sm:gap-2">
        {periodStart && periodEnd && (
          <span className="truncate">
            Period: {periodStart} to {periodEnd}
          </span>
        )}
        <div className="flex gap-2 text-xs">
          {cacheStatus && (
            <span>
              Cache: <span className={cacheStatus === 'HIT' ? 'text-green-600 dark:text-green-400' : 'text-orange-600 dark:text-orange-400'}>
                {cacheStatus}
              </span>
            </span>
          )}
          {responseTimeMs !== undefined && (
            <span>
              • {responseTimeMs}ms
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChartMetadata;
